import React, { Component } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";

import PasswordInput from "../../UtilFormInputs/PasswordInput/PasswordInput.component";
import SubmitButton from "../../UtilFormInputs/SubmitButton/SubmitButton.component";
import SubmitButtonNewAccount from "../../UtilFormInputs/SubmitButton/SubmitButtonNewAccount.component";
import { enhancedInput } from "../../../../../../components/utils/InputHOC/InputHOC";
import BaseInputComponent from "../../../../../../components/utils/InputHOC/BaseInputComponent.component";
import { baseInputStrings } from "../../../../../../components/utils/InputHOC/BaseInput.strings";

export interface LoginFormProps {
    onSubmit?: (credentials) => {};
    onChangePage: any;
}

const initialValues = {
    email: "",
    password: ""
};

const validationSchema = Yup.object().shape({
    email: Yup.string().required("e-mail is required"),
    password: Yup.string().required("Password is required")
});

export default class LoginForm extends Component<LoginFormProps, {}> {
    handleKeyPress = (e, formikProps) => {
        if (e.keyCode === 13 && e.shiftKey === false) {
            if (formikProps.isValid) {
                this.props.onSubmit(formikProps.values);
            }
        }
    };

    render() {
        const emailInput = enhancedInput({
            WrappedComponent: BaseInputComponent,
            id: "Email",
            placeholder: baseInputStrings.EMAIL,
            inputType: "email"
        });

        return (
            <div className="auth-form">
                <Formik
                    initialValues={initialValues}
                    onSubmit={values => this.props.onSubmit(values)}
                    validationSchema={validationSchema}
                    render={props => {
                        return (
                            <div onKeyDown={e => this.handleKeyPress(e, props)}>
                                <Form>
                                    <Field
                                        className="auth-form-input"
                                        name="email"
                                        component={emailInput}
                                    />
                                    <Field
                                        className="auth-form-input"
                                        name="password"
                                        component={PasswordInput}
                                    />
                                    <div className="auth-form-btns">
                                        <Field component={SubmitButton} />
                                        <Field
                                            component={() => <SubmitButtonNewAccount
                                                onChangePage={this.props.onChangePage} />} />
                                    </div>
                                </Form>
                            </div>
                        );
                    }}
                />
            </div>
        );
    }
}
